import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'sklAbsoluteNumber' })
export class AbsoluteNumberPipe implements PipeTransform {
    public transform(value: number): number {
        return !value ? 0 : Math.abs(value);
    }
}
